<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">{{ 'receipts.ui.filtri' | transloco }}</span>
  <button mat-icon-button type="button" [attr.aria-label]="'receipts.ui.chiudi' | transloco" class="close-button" (click)="close()">
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  <mat-form-field appearance="outline">
    <mat-label>{{ 'receipts.ui.dal' | transloco }}</mat-label>
    <input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="dateFrom" [placeholder]="'receipts.ui.datePlaceholder' | transloco" />
    <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker" />
    <mat-datepicker #dateFromPicker />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'receipts.ui.al' | transloco }}</mat-label>
    <input
      matInput
      [matDatepicker]="dateToPicker"
      [min]="dateFrom"
      [(ngModel)]="dateTo"
      [placeholder]="'receipts.ui.datePlaceholder' | transloco"
    />
    <mat-datepicker-toggle matIconSuffix [for]="dateToPicker" />
    <mat-datepicker #dateToPicker />
    @if (dateRangeInvalid) {
      <mat-error>{{ 'receipts.ui.laDataAlNonPuoEsserePrecedenteAllaDataDal' | transloco }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'receipts.ui.statoBrogliaccio' | transloco }}</mat-label>
    <mat-select multiple [(ngModel)]="selectedStatuses">
      @for (status of statusOptions; track status.value) {
        <mat-option [value]="status.value">{{ status.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="buttons-container">
  <button matButton type="button" (click)="reset()">{{ 'receipts.ui.cancella' | transloco }}</button>
  <button matButton="filled" type="button" (click)="apply()">{{ 'receipts.ui.applica' | transloco }}</button>
</mat-dialog-actions>
